import type { FC, ReactNode } from 'react'

import type { WhiteLabel } from '@skytech/types'
import { twJoin } from 'tailwind-merge'

import './styles.scss'

export type InfoBoxEmphasis = 'info' | 'warning' | 'error' | 'success'

export const InfoBox: FC<{
  children: ReactNode
  marginBottom?: number | 'px' | 'auto'
  marginRight?: number | 'px' | 'auto'
  marginTop?: number | 'px' | 'auto'
  marginLeft?: number | 'px' | 'auto'
  emphasis?: InfoBoxEmphasis
  className?: string
  whiteLabel?: WhiteLabel
}> = ({
  children,
  emphasis = 'info',
  className = '',
  marginBottom = 0,
  marginRight = 0,
  marginTop = 0,
  marginLeft = 0,
  whiteLabel: _whiteLabel,
}) => {
  // todo: replace with the org from url when ready
  const storedWhiteLabel = localStorage.getItem('org') as WhiteLabel
  const whiteLabel = _whiteLabel || storedWhiteLabel || 'control'

  return (
    <div
      className={twJoin(
        'ui-info-box',
        emphasis,
        whiteLabel,
        typeof marginBottom == 'number' && marginBottom < 0
          ? `-mb-${marginBottom}`
          : `mb-${marginBottom}`,
        typeof marginRight == 'number' && marginRight < 0
          ? `-mr-${marginRight}`
          : `mr-${marginRight}`,
        typeof marginTop == 'number' && marginTop < 0 ? `-mt-${marginTop}` : `mt-${marginTop}`,
        typeof marginLeft == 'number' && marginLeft < 0 ? `-ml-${marginLeft}` : `ml-${marginLeft}`,
        className
      )}
    >
      {children}
    </div>
  )
}
